{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Atribut Kustom",
    "HEADER_BTN_TXT": "Tambah Atribut Kustom",
    "LOADING": "Mengambil atribut kustom",
    "DESCRIPTION": "A custom attribute tracks additional details about your contacts or conversations—such as the subscription plan or the date of their first purchase. You can add different types of custom attributes, such as text, lists, or numbers, to capture the specific information you need.",
    "LEARN_MORE": "Learn more about custom attributes",
    "COUNT": "{n} attribute | {n} attributes",
    "SEARCH_PLACEHOLDER": "Cari atribut...",
    "NO_RESULTS": "No attributes found matching your search",
    "ATTRIBUTE_MODELS": {
      "CONVERSATION": "Percakapan",
      "CONTACT": "Kontak",
      "COMPANY": "Perusahaan"
    },
    "ATTRIBUTE_TYPES": {
      "TEXT": "Teks",
      "NUMBER": "Nomor",
      "LINK": "Tautan",
      "DATE": "Date",
      "LIST": "Daftar",
      "CHECKBOX": "Kotak centang"
    },
    "ADD": {
      "TITLE": "Tambah Atribut Kustom",
      "SUBMIT": "Buat",
      "CANCEL_BUTTON_TEXT": "Batalkan",
      "FORM": {
        "NAME": {
          "LABEL": "Nama Tampilan",
          "PLACEHOLDER": "Masukkan nama tampilan atribut kustom",
          "ERROR": "Nama dibutuhkan"
        },
        "DESC": {
          "LABEL": "Deskripsi",
          "PLACEHOLDER": "Masukkan deskripsi atribut kustom",
          "ERROR": "Deskripsi dibutuhkan"
        },
        "MODEL": {
          "LABEL": "Berlaku untuk",
          "PLACEHOLDER": "Silakan pilih salah satu",
          "ERROR": "Model dibutuhkan"
        },
        "TYPE": {
          "LABEL": "Tipe",
          "PLACEHOLDER": "Silakan pilih sebuah tipe",
          "ERROR": "Tipe dibutuhkan",
          "LIST": {
            "LABEL": "Nilai Daftar",
            "PLACEHOLDER": "Masukkan nilai dan tekan tombol enter",
            "ERROR": "Minimal harus memiliki satu nilai"
          }
        },
        "KEY": {
          "LABEL": "Kunci",
          "PLACEHOLDER": "Masukkan kunci atribut kustom",
          "ERROR": "Kunci dibutuhkan",
          "IN_VALID": "Kunci tidak valid"
        },
        "REGEX_PATTERN": {
          "LABEL": "Regex Pattern",
          "PLACEHOLDER": "Please enter custom attribute regex pattern. (Optional)"
        },
        "REGEX_CUE": {
          "LABEL": "Regex Cue",
          "PLACEHOLDER": "Please enter regex pattern hint. (Optional)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Enable regex validation"
        },
        "BADGES": {
          "PRE_CHAT": "Pre-chat",
          "RESOLUTION": "Resolution"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Atribut Kustom berhasil ditambahkan!",
        "ERROR_MESSAGE": "Tidak dapat membuat Atribut Kustom. Harap coba lagi nanti."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Hapus",
      "API": {
        "SUCCESS_MESSAGE": "Atribut Kustom berhasil dihapus.",
        "ERROR_MESSAGE": "Tidak dapat menghapus Atribut Kustom. Coba lagi."
      },
      "CONFIRM": {
        "TITLE": "Anda yakin akan menghapus - {attributeName}",
        "PLACE_HOLDER": "Silakan ketik {attributeName} untuk konfirmasi",
        "MESSAGE": "Menghapus akan menghapus atribut kustom",
        "YES": "Hapus ",
        "NO": "Batalkan"
      }
    },
    "EDIT": {
      "TITLE": "Edit Atribut Kustom",
      "UPDATE_BUTTON_TEXT": "Perbarui",
      "TYPE": {
        "LIST": {
          "LABEL": "Nilai Daftar",
          "PLACEHOLDER": "Masukkan nilai dan tekan tombol enter"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Atribut Kustom berhasil diperbarui",
        "ERROR_MESSAGE": "Ada kesalahan dalam memperbarui Atribut Kustom, harap coba lagi"
      }
    },
    "TABS": {
      "HEADER": "Atribut Kustom",
      "CONVERSATION": "Percakapan",
      "CONTACT": "Kontak",
      "COMPANY": "Perusahaan"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Nama",
        "DESCRIPTION": "Deskripsi",
        "TYPE": "Tipe",
        "KEY": "Kunci"
      },
      "BUTTONS": {
        "EDIT": "Edit",
        "DELETE": "Hapus"
      },
      "EMPTY_RESULT": {
        "404": "Tidak ada atribut kustom yang dibuat",
        "NOT_FOUND": "Tidak ada atribut kustom yang dikonfigurasi"
      },
      "REGEX_PATTERN": {
        "LABEL": "Regex Pattern",
        "PLACEHOLDER": "Please enter custom attribute regex pattern. (Optional)"
      },
      "REGEX_CUE": {
        "LABEL": "Regex Cue",
        "PLACEHOLDER": "Please enter regex pattern hint. (Optional)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Enable regex validation"
      }
    },
    "BADGES": {
      "PRE_CHAT": "Pre-chat",
      "RESOLUTION": "Resolution"
    }
  }
}
